import React, { useEffect, useState } from "react";
import { expireyHistory, deductHistory, changeTeacherHistory } from "../../../../Api/apiUtils";
import { Card, EmptyState, Field, Loader, Select, Table, Toolbar } from "../../../../ui";
import { Callout } from "./ui-pending";
import "./studentHistory.scss";

interface StudentHistoryData {
  id?: number;
  ActionPerformedBy?: string;
  CreatedOn?: string;
  newTeacherName?: string;
  oldCourseName?: string;
  oldTeacherName?: string;
  reason?: string;
  toMobileNumber?: string;
  toStudentId?: string;
  toUserName?: string;
  userPerformScenario?: string;
  NewExpiryDate?: string;
  PreviousExpiryDate?: string;
  Reasons?: string;
  cancelTime?: string; // Added for deduction history
  classDate?: string; // Added for deduction history
  classEndTime?: string; // Added for deduction history
  courseName?: string; // Added for deduction history
  courseId?: string; // Added for deduction history
  classStartTime?: string; // Added for deduction history
  oldTeacherId: any;
  teacherChangeDate: any;
}

interface StudentHistoryProps {
  studentId: string;
  profileData: any;
}

const historyTypes = [
  // { key: "expiry", label: "Expiry History" },
  { key: "change_teacher", label: "Change Teacher History" },
  { key: "deduction", label: "Deduction History" },
  { key: "course_change", label: "Course Change History" },
];

const StudentHistory: React.FC<StudentHistoryProps> = ({ studentId, profileData }) => {
  const [historyData, setHistoryData] = useState<StudentHistoryData[]>([]);
  const [changeTeacherData, setChangeTeacherData] = useState<StudentHistoryData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedHistory, setSelectedHistory] = useState<string>("change_teacher");

  useEffect(() => {
    const fetchHistory = async () => {
      // If course change is selected, open the URL in a new window and return early
      if (selectedHistory === "course_change") {
        window.open(`https://prod-mb.artiumacademy.com/question/464-course-change-history?mobile_number=${profileData.mobileNumber}`, '_blank');
        return;
      }

      const selectedCourse = JSON.parse(localStorage.getItem("selectedCourse") || "null");
      setLoading(true);
      setError(null);

      try {
        let response;
        switch (selectedHistory) {
          case "deduction":
            response = await deductHistory(studentId);
            const deductionData = response;

            if (deductionData) {
              const dataArray = Array.isArray(deductionData) ? deductionData : [deductionData];
              setHistoryData(dataArray);
            } else {
              setHistoryData([]);
            }
            break;
          case "change_teacher":
            response = await changeTeacherHistory(studentId);
            const changeTeacher = response;

            if (changeTeacher) {
              const dataArray = Array.isArray(changeTeacher) ? changeTeacher : [changeTeacher];
              setChangeTeacherData(dataArray);
            } else {
              setChangeTeacherData([]);
            }
            break;
          default:
            setHistoryData([]);
        }
      } catch (err) {
        // setError("Error fetching student history");
        setHistoryData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [studentId, selectedHistory, profileData.mobileNumber]);

  // Determine which data to display based on the selected history type
  const dataToDisplay = selectedHistory === "change_teacher" ? changeTeacherData : historyData;

  return (
    <Card title="Student history" flush>
      <div className="student-history__toolbar">
        <Toolbar>
          <Field label="History type">
            {(ctl) => (
              <Select
                {...ctl}
                value={selectedHistory}
                onChange={(e) => setSelectedHistory(e.target.value)}
                options={historyTypes.map((type) => ({ value: type.key, label: type.label }))}
              />
            )}
          </Field>
        </Toolbar>
      </div>
      {loading && <Loader label="Loading history…" />}
      {error && <Callout tone="danger">{error}</Callout>}

      {selectedHistory !== "course_change" && (
        Array.isArray(dataToDisplay) && dataToDisplay.length > 0 ? (
          <Table caption="Student history">
            <thead>
              <tr>
                {selectedHistory === "expiry" ? (
                  <>
                    <th>Performed By</th>
                    <th>Previous Expiry</th>
                    <th>New Expiry</th>
                    <th>Reason</th>
                    <th>Created on</th>
                  </>
                ) : selectedHistory === "deduction" ? (
                  <>
                    <th>Deducted on</th>
                    <th>Class Date</th>
                    <th>Class Start Time</th>
                    <th>Class End Time</th>
                    <th>Course Name</th>
                  </>
                ) : selectedHistory === "change_teacher" ? (
                  <>
                    <th>Performed By</th>
                    <th>New Teacher Name</th>
                    <th>Old Teacher Name</th>
                    <th>Reason</th>
                    <th>Change Date</th>
                    <th>Course Name</th>
                  </>
                ) : null}
              </tr>
            </thead>
            <tbody>
              {dataToDisplay.map((item, index) => (
                <tr key={item.id || index}>
                  {selectedHistory === "expiry" ? (
                    <>
                      <td>{item.ActionPerformedBy}</td>
                      <td>{new Date(item.PreviousExpiryDate || "").toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/,/g, '')}</td>
                      <td>{new Date(item.NewExpiryDate || "").toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/,/g, '')}</td>
                      <td>{item.Reasons || "N/A"}</td>
                      <td>{new Date(item.CreatedOn || "").toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/,/g, '')}</td>
                    </>
                  ) : selectedHistory === "deduction" ? (
                    <>
                      <td>{new Date(item.cancelTime || "").toLocaleDateString('en-US', { day: '2-digit', month: 'short', year:'numeric' }).replace(/,/g, '')}</td>
                      <td>{new Date(item.classDate || "").toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/,/g, '')}</td>
                      <td>{item.classStartTime}</td>
                      <td>{item.classEndTime}</td>
                      <td>{item.courseName}</td>
                    </>
                  ) : selectedHistory === "change_teacher" ? (
                    <>
                      <td>{item.ActionPerformedBy}</td>
                      <td>{item.newTeacherName}</td>
                      <td>{item.oldTeacherName}</td>
                      <td>{item.Reasons}</td>
                      <td>{new Date(item.teacherChangeDate || "").toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/,/g, '')}</td>
                      <td>{item.courseName}</td>
                    </>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <EmptyState title="No history available" description="Nothing has been recorded for this history type yet. Try another type." />
        )
      )}
    </Card>
  );
};

export default StudentHistory;